var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useController, useFormContext } from 'react-hook-form';
import withDesign from '../../../../../hocs/withDesign';
import { GenericComponent } from '../../../../atoms/GenericComponent';
import { RadioInput } from '../../../../atoms/RadioInput';
import { FormInput } from '../../FormInput';
export var RadioInputGroupComponent = function (_a) {
    var components = _a.components, schema = _a.schema, _b = _a.preItems, preItems = _b === void 0 ? [] : _b, _c = _a.posItems, posItems = _c === void 0 ? [] : _c, _d = _a.items, items = _d === void 0 ? [] : _d, name = _a.name;
    var allItems = [].concat(preItems, items, posItems);
    return (_jsx(GenericComponent, __assign({ as: "fieldset", schema: schema }, { children: allItems.map(function (input) {
            return (_jsx(FormInput, __assign({ name: name, design: components.radioInput, type: "radio" }, input), input.id));
        }) })));
};
export var FormRadioInputGroup = withDesign(RadioInputGroupComponent);
FormRadioInputGroup.displayName = 'FormRadioInputGroup';
export var ControlledRadioInputGroupComponent = function (_a) {
    var components = _a.components, schema = _a.schema, _b = _a.preItems, preItems = _b === void 0 ? [] : _b, _c = _a.posItems, posItems = _c === void 0 ? [] : _c, _d = _a.items, items = _d === void 0 ? [] : _d, name = _a.name, onChange = _a.onChange;
    var control = useFormContext().control;
    var _e = useController({
        name: name,
        control: control,
    }).field, formOnChange = _e.onChange, value = _e.value;
    var allItems = [].concat(preItems, items, posItems);
    return (_jsx(GenericComponent, __assign({ as: "fieldset", schema: schema }, { children: allItems.map(function (input) {
            return (_jsx(RadioInput, __assign({ name: name, design: components.radioInput, type: "radio", checked: input.value === value, onChange: function (e) {
                    formOnChange(e);
                    onChange === null || onChange === void 0 ? void 0 : onChange(e);
                } }, input), input.id));
        }) })));
};
export var FormControlledRadioInputGroup = withDesign(ControlledRadioInputGroupComponent);
FormControlledRadioInputGroup.displayName = 'FormControlledRadioInputGroup';
